/* eslint react/prop-types: 0 */
import React from "react";

import Layout from "./components/layout";
import SEO from "./components/seo";
import Banner from "./components/banner";
import Welcome from "./components/welcome";
import PropertyList from "./components/property-list";
import {
  theme1Vars,
  templateVariableValue,
} from "../../helpers/templateVariables";
import * as theme1Styles from "../theme1/scss/theme1.module.scss";

const Theme1 = ({ result, pageContext }) => {
  const {
    remarso: {
      domainByURL: {
        website: {
          templateConfiguration,
          template: { templateVariables },
          setting: display_settings,
          list,
        },
      },
    },
    currentLocaleKey: locale,
    defaultLocaleKey: defaultLocale,
  } = result;

  const { display_listings } = display_settings;

  const mainTitle = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-section-main-title",
    locale,
    defaultLocale
  );

  const section1 = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-section-1-text",
    locale,
    defaultLocale
  );
  const section1Title = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-section-1-title",
    locale,
    defaultLocale
  );
  const section1Logo = templateVariableValue(
    templateConfiguration,
    templateVariables,
    theme1Vars[1].slug,
    locale,
    defaultLocale
  );

  const section2 = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-section-2-text",
    locale,
    defaultLocale
  );
  const section2Title = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-section-2-title",
    locale,
    defaultLocale
  );
  const section2Logo = templateVariableValue(
    templateConfiguration,
    templateVariables,
    theme1Vars[2].slug,
    locale,
    defaultLocale
  );

  const section3 = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-section-3-text",
    locale,
    defaultLocale
  );
  const section3Title = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-section-3-title",
    locale,
    defaultLocale
  );
  const section3Logo = templateVariableValue(
    templateConfiguration,
    templateVariables,
    theme1Vars[3].slug,
    locale,
    defaultLocale
  );

  const listingTitle = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "home-listing-title",
    locale,
    defaultLocale
  );

  const metaTitle = templateVariableValue(
    templateConfiguration,
    templateVariables,
    "meta-title-home",
    locale,
    defaultLocale
  );

  const { properties } = pageContext;

  return (
    <Layout>
      <SEO metaTitle={metaTitle} />

      <Banner />

      {(() => {
        if (
          mainTitle ||
          section1 ||
          section1Title ||
          section1Logo ||
          section2 ||
          section2Title ||
          section2Logo ||
          section3 ||
          section3Title ||
          section3Logo
        ) {
          return (
            <section
              className={`${theme1Styles.homeContainet} ${theme1Styles.grey}`}
            >
              <div className={theme1Styles.wrapper}>
                {mainTitle && (
                  <h2 className={theme1Styles.secTl}>{mainTitle}</h2>
                )}

                <div className={theme1Styles.welRow}>
                  {(section1 || section1Title || section1Logo) && (
                    <div className={`${theme1Styles.colm}`}>
                      <Welcome
                        title={section1Title}
                        text={section1}
                        logo={section1Logo}
                      />
                    </div>
                  )}

                  {(section2 || section2Title || section2Logo) && (
                    <div className={`${theme1Styles.colm}`}>
                      <Welcome
                        title={section2Title}
                        text={section2}
                        logo={section2Logo}
                      />
                    </div>
                  )}

                  {(section3 || section3Title || section3Logo) && (
                    <div className={`${theme1Styles.colm}`}>
                      <Welcome
                        title={section3Title}
                        text={section3}
                        logo={section3Logo}
                      />
                    </div>
                  )}
                </div>
              </div>
            </section>
          );
        }
      })()}

      {(() => {
        if (
          display_listings &&
          (list.listing_type == 0 || list.listing_type == 1)
        ) {
          return (
            <section className={`${theme1Styles.homeContainet}`}>
              <div className={theme1Styles.wrapper}>
                <h2 className={`${theme1Styles.secTl}`}>{listingTitle}</h2>
                <PropertyList
                  properties={properties.slice(0, 4)}
                  locale={locale}
                  defaultLocale={defaultLocale}
                />
              </div>
            </section>
          );
        }
      })()}
    </Layout>
  );
};

export default Theme1;
